var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerflightgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 483,
    height: 176,
    viewBox: "0 0 483 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h483v176H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0.279
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.563
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M.308.733h190.039v164.524H.307z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#606060",
    stopOpacity: 0.279
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.563
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.57.163A.582.582 0 0 0 .469.25C.055.725.506 1.861.506 1.861s3.32 3.62 5.784 5.441c.638.473 1.22.821 1.669.96 1.924.584 33.044 3.158 40.713 3.784l1.534.128.048.002c.075.008.115.008.115.008S48.392 9.827 45.91 8.99c-2.042-.688-29.342-5.811-40.1-7.947C3.48.58 1.927.256 1.573.15a2.02 2.02 0 0 0-.578-.1.729.729 0 0 0-.424.113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M.67.57c2.118.806 1.948 2.88 1.948 2.88L4.24 22.423c.649 7.603 1.299 15.208 1.947 22.813 0 0 8.536-2.885 15.354-5.628.533-.214 1.054-.429 1.558-.64a75.448 75.448 0 0 0 3.385-1.493c2.456-1.166 3.893-2.117 3.207-2.522-2.523-1.49-5.663-6.4-9.52-11.269-.304-.38-.627-.84-.968-1.362-2.662-4.077-6.328-12.003-8.586-16.987-1.011-2.23-1.74-3.868-1.97-4.312-.105-.203-1.079-.553-1.3-.601C6.147.17 4.227.038 2.702.038.958.038-.273.21.67.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M4.722 8.854c-.383.196-.747.396-1.086.595-.263.152-.511.311-.745.465C.875 11.26-.104 12.697.52 14.194c0 0 9.446.38 16.696-.279 7.25-.657 15.42-3.495 17.366-3.077.132.028.718.094 1.686.191 12.952 1.299 94.833 8.22 94.833 8.22s2.173-.165 3.361-1.307c.103-.104-.537-.323-1.794-.639-.358-.086-.766-.185-1.223-.288-.53-.124-1.13-.257-1.785-.399C111.238 12.645 45.988 1.452 40.949.453a4.498 4.498 0 0 1-.292-.065 1.103 1.103 0 0 0-.263-.02c-2.9 0-25.886 3.477-35.672 8.486"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M7.597.791C2.305 2.347-.93 6.56.318 10.05c1.25 3.49 6.478 4.834 11.805 3.382 6.546-1.784 8.063-5.818 6.813-9.309-.903-2.523-3.464-4.01-6.957-4.01-1.338 0-2.813.218-4.382.68"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: "33.582%",
    cy: "17.37%",
    r: "109.917%",
    fx: "33.582%",
    fy: "17.37%",
    gradientTransform: "matrix(.72049 -.01673 .01098 .91104 .092 .021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M7.756 1.06C2.464 2.615-.771 6.828.477 10.317c1.25 3.491 6.478 4.835 11.805 3.383 6.545-1.785 8.062-5.818 6.812-9.308C18.19 1.868 15.63.38 12.138.38 10.8.38 9.325.6 7.756 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M1.442.411c-.116.033-.227.075-.337.115C.227 1.777-.055 3.492.501 5.187c.751 2.295 2.791 3.834 4.921 3.914C7.077 8.087 7.84 5.922 7.143 3.792 6.446 1.667 4.526.26 2.549.26c-.37 0-.74.05-1.107.152"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: "151.118%",
    cy: "76.579%",
    r: "80.639%",
    fx: "151.118%",
    fy: "76.579%",
    gradientTransform: "matrix(.99986 -.0136 .01524 .74037 -.011 .22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M9.816 1.075C3.146 3.035-.934 8.346.641 12.745c1.576 4.4 8.164 6.093 14.88 4.264 8.251-2.25 10.164-7.335 8.588-11.734C22.971 2.093 19.743.218 15.34.218c-1.686 0-3.544.276-5.523.857"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "33.582%",
    cy: "17.371%",
    r: "109.916%",
    fx: "33.582%",
    fy: "17.371%",
    gradientTransform: "matrix(.7205 -.01673 .01098 .91104 .092 .021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "M9.608 1.187C2.937 3.148-1.142 8.457.433 12.857c1.575 4.4 8.165 6.094 14.88 4.265 8.251-2.25 10.163-7.336 8.587-11.735C22.762 2.206 19.534.33 15.13.33c-1.686 0-3.544.275-5.522.857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    d: "M1.96.502a5.229 5.229 0 0 0-.423.145C.428 2.222.075 4.385.775 6.522c.947 2.892 3.518 4.832 6.203 4.934 2.086-1.279 3.047-4.008 2.17-6.692C8.27 2.085 5.847.31 3.355.31A5.14 5.14 0 0 0 1.96.502"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: "151.121%",
    cy: "76.578%",
    r: "80.641%",
    fx: "151.121%",
    fy: "76.578%",
    gradientTransform: "matrix(.99986 -.0136 .01524 .74034 -.011 .22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: "50%",
    x2: "17.901%",
    y1: "92.624%",
    y2: "-7.094%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96.611%",
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2B8CAB"
  })), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M6.07.238S1.285-.21.585.182c0 0-.53.045.085.388 0 0 1.898.79 1.898 2.584l1.81 21.2 1.81 20.883L24.8 38.261 6.07.238z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "C",
    width: "116.4%",
    height: "106.6%",
    x: "-4.1%",
    y: "-2.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    values: "0 0 0 0 0.846673044 0 0 0 0 0.846673044 0 0 0 0 0.846673044 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: "74.777%",
    x2: "74.777%",
    y1: "0%",
    y2: "57.392%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "F",
    d: "M156.39.421c-6.253.006-14.562.989-25.046 3.892-10.84 3.002-49.947 14.403-79.382 23.086a5887.222 5887.222 0 0 0-23.801 7.062c-5.99 1.795-9.948 3.003-10.778 3.31a.126.126 0 0 0-.023.007c-1.568.585-4.35 1.939-7.22 3.664-.738.445-1.484.912-2.215 1.4-1.759 1.17-3.442 2.443-4.784 3.728-1.139 1.087-2.031 2.183-2.52 3.226a4.376 4.376 0 0 0-.364 1.135s-1.177 2.005 6.846 4.67c8.27 2.743 26.78 4.656 36.972 4.77 2.695.03 8.005-.22 10.536-.62 21.41-3.364 82.07-17.403 92.206-19.989 3.797-.97 8.904-2.352 14.103-4.256a83.857 83.857 0 0 0 5.982-2.435 61.6 61.6 0 0 0 3.247-1.59c2.852-1.507 5.486-3.211 7.645-5.141 1.769-1.578 3.23-3.303 4.24-5.193.538-1.007.836-1.916.955-2.736.214-1.494-.172-2.694-.809-3.676-1.243-1.902-3.263-3.69-3.851-4.525-.588-.832-2.525-2.494-4.99-4.681-1.258-1.121-2.698-2.194-4.26-2.997-.88-.453-1.8-.82-2.746-1.06-2.372-.601-5.645-1.048-9.857-1.05h-.086z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: "56.633%",
    x2: "50%",
    y1: "-27.184%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M5.53.565c-.64.11-1.408.258-2.163.458C1.727 1.455.143 2.127 0 3.11c-.058.396 3.507 1.363 9.341 2.684 24.895 5.638 91.101 17.705 93.374 19.297 2.804 1.965 17.417 7.896 21.025 10.95 6.854 5.806 8.524 6.99 18.46 3.785 5.66-1.823 10.882-3.657 15.972-5.945 3.707-1.664 5.817-4.055 4.937-5.94 0 0-.33-3.76-4.895-6.905-.59-.403-1.2-.77-1.831-1.088a14.786 14.786 0 0 0-1.828-.76c-3.44-1.176-7.6-1.366-11.494-1.458-2.63-.06-5.14-.077-7.22-.32C129.942 16.719 7.118.348 7.118.348S6.453.413 5.53.565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M11.27 1.342C3.512 3.802-1.12 10.118.841 15.23c1.963 5.11 9.72 6.929 17.531 4.622 9.598-2.837 11.7-8.836 9.738-13.947C26.73 2.3 23.053.198 18.09.198c-2.073 0-4.372.367-6.82 1.144"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "M",
    cx: "32.962%",
    cy: "18.101%",
    r: "109.22%",
    fx: "32.962%",
    fy: "18.101%",
    gradientTransform: "matrix(.72654 -.03785 .02508 .91066 .086 .029)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M11.014 1.267C3.258 3.727-1.373 10.043.588 15.154c1.962 5.11 9.72 6.93 17.53 4.622 9.599-2.837 11.701-8.836 9.739-13.945C26.474 2.225 22.797.123 17.834.124c-2.073 0-4.372.367-6.82 1.143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    d: "M1.946.378c-.17.053-.33.116-.492.18C.2 2.431-.156 4.971.72 7.456c1.186 3.36 4.247 5.569 7.392 5.62 2.408-1.547 3.46-4.765 2.36-7.886C9.39 2.123 6.577.118 3.705.118c-.589 0-1.18.084-1.759.26"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "R",
    cx: "151.291%",
    cy: "75.058%",
    r: "80.131%",
    fx: "151.291%",
    fy: "75.058%",
    gradientTransform: "matrix(.99928 -.03117 .03449 .74994 -.025 .235)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M10.328 1.058C3.24 3.305-.991 9.076.8 13.745c1.792 4.67 8.88 6.332 16.017 4.224 8.77-2.591 10.691-8.074 8.898-12.742C24.453 1.932 21.094.013 16.559.013c-1.894 0-3.994.335-6.231 1.045"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "U",
    cx: "32.961%",
    cy: "18.1%",
    r: "109.22%",
    fx: "32.961%",
    fy: "18.1%",
    gradientTransform: "matrix(.72656 -.03785 .02508 .91066 .086 .029)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("path", {
    id: "W",
    d: "M10.264 1.064C3.177 3.311-1.054 9.082.737 13.752c1.793 4.67 8.88 6.332 16.017 4.224 8.77-2.592 10.69-8.073 8.898-12.743C24.388 1.94 21.029.02 16.495.02c-1.894 0-3.994.335-6.23 1.044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    d: "M1.653.425a5.75 5.75 0 0 0-.45.163C.059 2.3-.267 4.62.533 6.89c1.084 3.072 3.881 5.089 6.755 5.137 2.2-1.416 3.16-4.355 2.156-7.206C8.455 2.019 5.885.187 3.261.187a5.49 5.49 0 0 0-1.608.238"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Z",
    cx: "151.289%",
    cy: "75.059%",
    r: "80.13%",
    fx: "151.289%",
    fy: "75.059%",
    gradientTransform: "matrix(.99928 -.03117 .03449 .74995 -.025 .235)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    d: "M5.852.214C2.954.404.124 2.184.124 2.184s.043.01.125.022l.052.008c.27.043.846.132 1.672.26 8.35 1.304 42.248 6.562 44.474 6.478.52-.022 1.247-.213 2.07-.51 3.184-1.142 7.83-3.804 7.83-3.804s.831-.983.538-1.543a.536.536 0 0 0-.08-.11c-.164-.176-.492-.284-1.063-.263-.409.016-2.161-.06-4.782-.194C39.34 1.936 10.65.205 6.268.204c-.182 0-.321.003-.416.01"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: "111.179%",
    x2: "50%",
    y1: "21.975%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    d: "M178.329.808s7.944 5.743 3.705 10.937c0 0-2.409 10.529-37.1 19.082 0 0-76.828 17.105-84.093 18.502 0 0-25.56 4.908-53.738-3.132 0 0-9.06-2.984-6.48-5.804 28.269 1.856 46.538 1.959 54.808.308 21.62-4.316 48.185-13.37 79.695-27.16L178.33.808z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: "128.043%",
    x2: "12.51%",
    y1: "-22.935%",
    y2: "114.959%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#181818"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.407
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M46.253 24.815a9.59 9.59 0 0 0-4.337-.567c-1.29 1.22-3.702 1.567-5.474 1.684-1.825-1.771-4.025-3.42-6.295-4.57-1.516-.769-3.287-1.58-3.755-3.211-.746-2.607-5.216-3.657-7.866-3.059-3.36-.907-7.196.261-9.894 2.457-1.192.97.15 3.374 1.177 4.514 1.03 1.14 2.307 2.413 2.066 3.928-1.243.635-2.93.67-4.325.606-.821-.037-1.664-.196-2.449.047-.784.242-1.466 1.091-1.164 1.852-.539.937-1.188 1.428-.562 2.31.488.685 1.316 1.25 1.31 2.093-.005.668-.57 1.208-1.17 1.508-.599.3-1.272.451-1.838.81C-.093 36.34-.11 38.868.079 40.954c1.144 1.402 1.324 3.819.773 5.542-.21.658-.548 1.356-.312 2.004.27.742 1.146 1.034 1.912 1.232 1.637.423 3.563.788 4.866-.288 3.434-2.836 8.764-1.367 13.112-.39 1.502.336 3.082.889 3.96 2.15 1.17 1.683.67 4.02-.294 5.828-.962 1.807-2.345 3.415-2.954 5.37-.572 1.832-.412 3.802-.247 5.714.203 2.356.45 4.835 1.818 6.765 1.434 2.022 2.339 5.042 2.224 7.516-.092 1.987-.794 3.94-.612 5.92.331 3.592 3.44 6.285 6.612 8.014 3.319 1.81 6.18 4.888 7.324 8.486.574 1.806.746 3.717 1.251 5.544a15.769 15.769 0 0 0 5.355 8.078c1.875 1.488 4.953 2.016 7.31 2.443 1.223.223 2.541.4 3.464 1.231.425.384.731.882 1.14 1.285 1.969 1.944 5.595 1.145 7.588 3.067.513.495.867 1.132 1.319 1.685 1.216 1.487 3.193 2.318 5.109 2.147-.448 1.46 1.305 3.177.764 4.604-.436 1.15-1.755 1.656-2.661 2.49-1.572 1.448-1.817 3.925-1.139 5.95.678 2.024 2.11 3.698 3.542 5.283 2.659 2.943 5.856 4.371 8.74 7.096 2.672 2.523 3.28 6.608 2.694 10.232-.588 3.624-2.18 6.997-3.316 10.489-2.124 6.522-2.638 13.69-.607 20.242 2.03 6.553 6.78 12.394 13.15 14.97.704.285 1.57-.208 2.085-.764a1.873 1.873 0 0 0 .265-2.113c-1.15-2.11-3.194-3.913-4.686-5.8-.468-.592-.962-1.265-.902-2.017.068-.845.797-1.456 1.334-2.112a5.46 5.46 0 0 0 1.221-3.574c-.033-1.208-.738-2.39-.697-3.599.041-1.208.695-2.48 1.842-2.87.522-.177 1.102-.161 1.606-.383 1.659-.73 1.395-3.256 2.595-4.612.556-.63 1.377-.943 2.135-1.307 3.208-1.54 5.846-4.59 6.14-8.13.233-2.833-.8-6.272 1.358-8.127 1.98-1.704 5.027-.574 7.608-.99 1.05-.171 1.75-1.146 2.241-2.088.492-.94.548-2.06.372-3.105-.218-1.288-.772-2.547-.65-3.847.173-1.83 1.606-3.24 2.716-4.706a15.53 15.53 0 0 0 2.739-5.858c.557-2.418-.993-5.272-3.165-6.478-2.172-1.206-4.777-1.24-7.262-1.311-2.485-.071-5.117-.259-7.147-1.69-1.86-1.312-2.91-3.457-4.38-5.192-2.48-2.927-6.086-4.618-9.575-6.222-1.316-.605-2.794-1.223-4.17-.771-.544.178-1.033.515-1.594.623-1.54.294-2.786-1.159-4.166-1.902-2.864-1.543-6.977.692-7.233 3.93-1.48.51-4.225.07-5.065-1.249-.605-.95-.847-2.278-1.888-2.71-.557-.231-1.253-.145-1.705-.542-.749-.66-.166-1.85-.033-2.84.214-1.575-.965-3.074-2.404-3.76-1.437-.686-3.085-.742-4.678-.793-1.593-.05-3.243-.123-4.668-.836-2.775-1.388-3.912-5.145-2.694-7.995 1.217-2.85 4.403-4.607 7.505-4.518 3.04.087 6.25 2.305 6.284 5.34.009.77 1.244.856 1.914.475.67-.381 1.02-1.151 1.184-1.903.164-.752.187-1.535.418-2.268.533-1.701 2.26-2.951 4.044-2.932 1.862.021 3.17-1.833 4.49-3.142 1.323-1.31 2.114-3.285 1.592-5.069-.282-.962-.925-1.934-.603-2.883.252-.743 1.017-1.175 1.743-1.48a14.984 14.984 0 0 1 6.382-1.141c1.897.08 2.872-1.11 3.84-2.74.7-1.177 1.01-2.666 2.125-3.465 1.667-1.196 3.972-.14 6.02-.277 2.99-.202 5.326-3.55 4.476-6.419-.403-1.364-1.36-2.482-2.136-3.675a15.63 15.63 0 0 1-2.217-5.409c-.358-1.765-.46-3.708-1.626-5.082-1.822.085-4.03.032-5.653.868-.32-1.852-.674-3.784-1.82-5.276-1.145-1.492-3.347-2.356-4.97-1.4-1.584.933-1.928 3.103-1.634 4.916.293 1.814 1.046 3.568.997 5.404-.05 1.837-1.328 3.865-3.167 3.816-.96-.026-1.817-.61-2.491-1.29-.966-.974-1.73-2.22-2.971-2.804-.951-.448-2.046-.44-3.073-.669-3.499-.783-5.899-4.79-4.933-8.237.967-3.447 5.102-5.63 8.5-4.487 4.116-1.506 5.792-6.687 4.15-10.743-1.642-4.057-6.056-6.575-10.436-6.767-1.282-.057-2.588.056-3.832-.258-3.515-.888-5.355-4.744-8.414-6.687-2.012-1.278-6.663-.055-8.894-.896M101.661 12.279c-1.352 2.06.163 4.867 2.131 6.351 1.97 1.485 4.432 2.374 5.99 4.285 2.502 3.07 1.79 7.61.42 11.325-1.37 3.713-3.303 7.47-2.833 11.4.222 1.853.98 3.611 1.967 5.196.957 1.534 2.261 3.012 4.022 3.435 2.238.539 4.506-.776 6.203-2.329 1.697-1.552 3.171-3.432 5.237-4.443 2.978-1.457 6.808-.914 9.402-2.977 3.21-2.552 2.734-7.421 3.617-11.422 1.482-6.718 7.306-11.68 9.584-18.171.446-1.27.752-2.605.721-3.951-.099-4.347-3.767-7.96-7.876-9.407-5.071-1.785-10.194-.665-15.4-.901-2.829-.128-5.955-1.323-8.693-.177-4.225 1.769-2.985 5.927-5.753 8.395-2.394 2.134-6.814.46-8.739 3.39",
    transform: "translate(114 6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251.448 17.428)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M78.33 27.191c-2.42-2.35-6.372-.076-8.885 2.175l-7.493 6.711c-1.877 1.682-3.896 3.434-6.383 3.85-2.487.416-5.478-1.158-5.58-3.674 1.701-1.598 5.091.778 6.645-.964 1.377-1.546-.66-3.756-2.455-4.79-3.281-1.893-6.67-3.822-10.425-4.332-3.756-.51-8.012.742-9.961 3.985-1.67 2.776-1.363 6.397-3.017 9.182-1.034 1.743-2.738 2.99-3.913 4.642-1.174 1.653-1.677 4.148-.239 5.577 1.161 1.155 3.136 1.156 4.285 2.323.884.898 1.187 2.397 2.346 2.892 1.326.565 2.825-.71 3.143-2.114.317-1.404-.13-2.85-.36-4.271-.689-4.247 1.446-9.469 5.715-10.076.971.037 1.293 1.423.858 2.29-.437.868-1.285 1.47-1.744 2.325-.865 1.613.14 3.91 1.913 4.373 1.848.484 4.937.095 4.692 1.986-.258 2.009-3.98.693-5.186 2.323-.71.961-.083 2.3-.099 3.495-.033 2.335-2.615 3.856-4.949 4.022-2.334.165-4.672-.525-7.002-.314-2.33.212-4.868 1.86-4.761 4.193a61.26 61.26 0 0 1-10.026 3.66c.147 2.528 4.924 2.764 4.906 5.296-.011 1.52-1.897 2.31-3.415 2.199-1.519-.113-3.05-.715-4.523-.327-2.543.67-3.434 4.24-2.027 6.457 1.41 2.217 4.304 3.097 6.926 2.89 1.05-.082 2.176-.362 2.833-1.183.629-.786.68-1.866.944-2.835.59-2.17 2.446-3.95 4.642-4.45 1.24-.282 2.758-.304 3.423-1.385 2.834 1.53 4.829 4.515 5.154 7.716.912 1.174 2.943-.34 2.744-1.812-.198-1.473-1.5-2.495-2.537-3.563-1.036-1.067-1.9-2.727-1.088-3.973 4.845 1.421 8.761 5.624 9.83 10.548 1.689-.335 2.621-2.616 1.65-4.035.525-1.176 2.449-.504 3.002.66.553 1.161.503 2.596 1.294 3.613 2.287 2.941 8.41-.647 10.284 2.572 1.312 2.258-1.646 4.889-4.26 4.809-2.614-.08-5-1.572-7.602-1.831-2.873-.286-5.664.947-8.53 1.28-2.868.333-6.403-.784-7.007-3.602-.163-.758-.097-1.593-.5-2.257-.572-.944-1.86-1.162-2.958-1.038-4.769.54-9.61 5.45-13.55 2.715-2.517 4.894-8.676 6.733-12.113 11.035-3.738 4.68-3.424 11.91.206 16.675 3.63 4.765 10.045 7.016 15.996 6.265 1.362-.173 2.798-.477 4.067.046 1.258.519 2.063 1.733 3.112 2.597 1.048.864 2.79 1.295 3.658.25-.995 2.463-.72 5.4.719 7.634 1.552 2.413 4.446 4.319 4.386 7.186-.03 1.483-.895 2.808-1.3 4.237-1.852 6.542 5.894 11.88 7.118 18.567.33 1.8.329 3.97 1.852 4.986.701.468 1.58.562 2.423.618 4.32.283 9.758-1 10.657-5.226.254-1.196.072-2.434.109-3.656.11-3.651 2.347-7.163 5.615-8.81.886-.448 1.861-.78 2.57-1.476 1.559-1.53 1.213-4.127.412-6.158-.8-2.032-1.966-4.08-1.685-6.246.45-3.476 4.19-5.312 7.022-7.383 4.264-3.12 7.192-8.001 7.933-13.226-3.933 1.232-8.748 2.283-11.745-.54-1.04-.98-1.678-2.296-2.295-3.583L58.245 97.33c-.245-.51-.494-1.091-.294-1.62.543-1.434 2.7-.238 3.533 1.05a124.64 124.64 0 0 1 7.975 14.336 31.817 31.817 0 0 0 13.256-5.752c1.244-.926 2.48-2.034 2.9-3.524.42-1.49-.351-3.401-1.88-3.667-.592-.103-1.194.046-1.79.109-3.608.376-6.74-2.366-9.099-5.115 1.615-1.807 4.553-.761 6.759.25a50.5 50.5 0 0 0 12.42 3.85c1.07.185 2.166.342 3.128.839.674.347 1.255.849 1.812 1.362a36.902 36.902 0 0 1 10.443 16.917c1.887.423 3.215-1.898 3.364-3.822.149-1.924-.078-4.144 1.311-5.487 1.09-1.056 2.883-1.201 3.84-2.379 1.207-1.483.575-3.983 1.985-5.276 1.765-1.62 4.621.36 5.563 2.563.942 2.201 1.285 4.909 3.268 6.255l3.21-.462a24.564 24.564 0 0 0 5.248 15.027c1.832-.956 1.002-3.735-.14-5.454-1.144-1.718-2.269-4.283-.643-5.556 2.256.022 3.308 3.126 5.499 3.657 2.18.527 4.127-2.06 3.734-4.264-.393-2.204-2.292-3.825-4.253-4.912-1.759-1.92.78-4.99 3.35-5.424 2.57-.434 5.382.296 7.71-.872 2.793-1.4 3.725-5.075 3.09-8.128-.636-3.053-2.449-5.704-3.932-8.448-1.265-2.344-1.891-6 .57-7.032.659-.275 1.396-.263 2.11-.293 9.305-.393 17.004-10.226 15.138-19.333-.352-1.717-1.017-3.422-2.245-4.673-2.212-2.253-5.967-2.782-7.62-5.472-2.02-3.29.48-7.654 3.716-9.767 3.236-2.112 7.19-3.03 10.212-5.437.805-.02 1.237-.808 1.385-1.6.093-.495-.03-1.005-.035-1.51-.01-1.385.98-2.72 2.313-3.111 1.331-.392 2.89.194 3.633 1.364.917 1.445.547 3.35-.118 4.926-.665 1.575-1.605 3.084-1.778 4.784-.172 1.7.794 3.699 2.495 3.89 2.08.233 3.426-2.231 3.56-4.316.137-2.085-.27-4.36.853-6.125 1.706-2.682 6.422-3.31 6.544-6.484.099-2.569-3.14-4.076-3.72-6.58-.234-1.01-.002-2.06.093-3.094.357-3.852-1.343-7.835-4.374-10.248-3.029-2.413-7.298-3.182-10.983-1.979-1.2.392-2.334.977-3.556 1.297-1.803.473-3.703.35-5.563.223l-9.985-.681c-2.979-.204-6.135-.372-8.777 1.014-3.861 2.025-6.052 7.074-10.382 7.598-3.054.37-5.776-1.737-8.636-2.867-4.626-1.827-10.211-.967-14.069 2.166-1.451-.738-1.004-2.894-1.514-4.436-.534-1.61-2.268-2.582-3.96-2.73-1.694-.148-3.367.367-4.982.894-3.48 1.134-7.527 3.068-7.849 6.707-.09 1.024.14 2.115-.292 3.048-.616 1.329-2.281 1.771-3.317 2.807-1.236 1.236-1.431 3.145-1.482 4.891-.051 1.745-.067 3.619-1.079 5.044-1.012 1.424-6.334 2.141-7.588.923",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M280.896 139.133c.803 1.165 2.13 1.847 3.433 2.4 1.576.667 3.492 1.187 4.913.232.97-.653 4.204-5.12 4.43-6.089.434-1.867-.191-1.76-2.058-2.138-3.026-.612-14.184.567-10.718 5.595M269.897 138.504c4.333 7.872 13.21 13.031 22.209 12.907.623-.637-.297-1.609-1.119-1.955-2.27-.958-4.714-1.435-7.042-2.25-2.327-.813-4.627-2.044-6.008-4.083-.576-.852-.97-1.812-1.444-2.724-1.366-2.626-6.704-9.246-10.044-7.66.87 1.826 2.387 3.837 3.448 5.765M293.42 156.838c-1.155 1.29-2.235 2.866-3.921 3.268-.997.237-2.06.013-3.059.243-2.935.678-3.617 4.616-2.949 7.549.668 2.932 2.043 6.009.947 8.81-.221.563-.542 1.115-.532 1.72.012.725.51 1.361 1.092 1.797 2.68 2.005 6.485.566 9.431-1.027 2.946-1.592 6.516-3.314 9.457-1.712 3.148 1.715 3.444 6.057 5.384 9.068 1.704 2.646 5.465 4.232 8.125 2.544.903-.575 1.573-1.44 2.224-2.29l3.997-5.213c1.763-2.3 3.59-4.75 3.929-7.626.656-5.552-4.274-10.01-8.723-13.409-.236-1.77-.491-3.594-1.395-5.135-1.814-3.087-5.518-3.415-4.508.958-2.901.1-5.249-4.2-8.477-4.613-3.928-.504-8.521 2.274-11.022 5.068",
    transform: "translate(114 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 335.58 113.016)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.57.163A.582.582 0 0 0 .469.25C.055.725.506 1.861.506 1.861s3.32 3.62 5.784 5.441c.638.473 1.22.821 1.669.96 1.924.584 33.044 3.158 40.713 3.784l1.534.128.048.002c.075.008.115.008.115.008S48.392 9.827 45.91 8.99c-2.042-.688-29.342-5.811-40.1-7.947C3.48.58 1.927.256 1.573.15a2.02 2.02 0 0 0-.578-.1.729.729 0 0 0-.424.113",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 367.55 64.753)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.67.57c2.118.806 1.948 2.88 1.948 2.88L4.24 22.423c.649 7.603 1.299 15.208 1.947 22.813 0 0 8.536-2.885 15.354-5.628.533-.214 1.054-.429 1.558-.64a75.448 75.448 0 0 0 3.385-1.493c2.456-1.166 3.893-2.117 3.207-2.522-2.523-1.49-5.663-6.4-9.52-11.269-.304-.38-.627-.84-.968-1.362-2.662-4.077-6.328-12.003-8.586-16.987-1.011-2.23-1.74-3.868-1.97-4.312-.105-.203-1.079-.553-1.3-.601C6.147.17 4.227.038 2.702.038.958.038-.273.21.67.57",
    mask: "url(#j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 291.249 101.276)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.722 8.854c-.383.196-.747.396-1.086.595-.263.152-.511.311-.745.465C.875 11.26-.104 12.697.52 14.194c0 0 9.446.38 16.696-.279 7.25-.657 15.42-3.495 17.366-3.077.132.028.718.094 1.686.191 12.952 1.299 94.833 8.22 94.833 8.22s2.173-.165 3.361-1.307c.103-.104-.537-.323-1.794-.639-.358-.086-.766-.185-1.223-.288-.53-.124-1.13-.257-1.785-.399C111.238 12.645 45.988 1.452 40.949.453a4.498 4.498 0 0 1-.292-.065 1.103 1.103 0 0 0-.263-.02c-2.9 0-25.886 3.477-35.672 8.486",
    mask: "url(#l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 210.684 106.929)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M7.597.791C2.305 2.347-.93 6.56.318 10.05c1.25 3.49 6.478 4.834 11.805 3.382 6.546-1.784 8.063-5.818 6.813-9.309-.903-2.523-3.464-4.01-6.957-4.01-1.338 0-2.813.218-4.382.68",
    mask: "url(#o)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 208.979 106.059)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "q",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.756 1.06C2.464 2.615-.771 6.828.477 10.317c1.25 3.491 6.478 4.835 11.805 3.383 6.545-1.785 8.062-5.818 6.812-9.308C18.19 1.868 15.63.38 12.138.38 10.8.38 9.325.6 7.756 1.06",
    mask: "url(#q)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 199.601 108.233)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M1.442.411c-.116.033-.227.075-.337.115C.227 1.777-.055 3.492.501 5.187c.751 2.295 2.791 3.834 4.921 3.914C7.077 8.087 7.84 5.922 7.143 3.792 6.446 1.667 4.526.26 2.549.26c-.37 0-.74.05-1.107.152",
    mask: "url(#t)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F6F8",
    d: "M194.77 107.087a4.3 4.3 0 0 1 1.255.158c1.183.333 2.131 1.149 2.673 2.294.546 1.16.612 2.516.184 3.82-.712 2.175-2.68 3.725-4.787 3.77a4.308 4.308 0 0 1-1.254-.16c-1.182-.332-2.13-1.146-2.672-2.294-.545-1.16-.611-2.517-.183-3.82.71-2.174 2.68-3.725 4.785-3.768m-.666 10.463c2.3-.048 4.443-1.72 5.212-4.068.458-1.4.385-2.861-.204-4.111-.595-1.262-1.645-2.16-2.955-2.528a4.783 4.783 0 0 0-1.397-.178c-2.3.048-4.442 1.721-5.21 4.068-.46 1.4-.387 2.861.203 4.112.595 1.261 1.645 2.16 2.955 2.529.453.127.923.187 1.396.176"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 234.555 99.972)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M9.816 1.075C3.146 3.035-.934 8.346.641 12.745c1.576 4.4 8.164 6.093 14.88 4.264 8.251-2.25 10.164-7.335 8.588-11.734C22.971 2.093 19.743.218 15.34.218c-1.686 0-3.544.276-5.523.857",
    mask: "url(#w)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 231.997 99.102)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#x"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.608 1.187C2.937 3.148-1.142 8.457.433 12.857c1.575 4.4 8.165 6.094 14.88 4.265 8.251-2.25 10.163-7.336 8.587-11.735C22.762 2.206 19.534.33 15.13.33c-1.686 0-3.544.275-5.522.857",
    mask: "url(#y)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 220.488 101.71)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M1.96.502a5.229 5.229 0 0 0-.423.145C.428 2.222.075 4.385.775 6.522c.947 2.892 3.518 4.832 6.203 4.934 2.086-1.279 3.047-4.008 2.17-6.692C8.27 2.085 5.847.31 3.355.31A5.14 5.14 0 0 0 1.96.502",
    mask: "url(#B)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F6F8",
    d: "M214.257 100.248c.537-.01 1.069.057 1.58.2 1.491.421 2.687 1.448 3.369 2.894.689 1.46.773 3.17.233 4.814-.897 2.74-3.379 4.695-6.034 4.752a5.416 5.416 0 0 1-1.58-.201c-1.491-.419-2.687-1.447-3.369-2.892-.688-1.46-.771-3.173-.231-4.815.896-2.741 3.376-4.695 6.032-4.752m-.84 13.192c2.899-.062 5.601-2.17 6.57-5.13.577-1.765.486-3.606-.257-5.182-.75-1.59-2.073-2.723-3.726-3.186a6.046 6.046 0 0 0-1.76-.225c-2.898.062-5.599 2.17-6.568 5.128-.578 1.766-.487 3.606.257 5.184.75 1.59 2.072 2.722 3.724 3.187.57.161 1.163.236 1.76.224"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 367.55 64.753)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#C)",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#E)",
    xlinkHref: "#D"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 364.567 63.013)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#F"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#G)",
    xlinkHref: "#F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.39.421c-6.253.006-14.562.989-25.046 3.892-10.84 3.002-49.947 14.403-79.382 23.086a5887.222 5887.222 0 0 0-23.801 7.062c-5.99 1.795-9.948 3.003-10.778 3.31a.126.126 0 0 0-.023.007c-1.568.585-4.35 1.939-7.22 3.664-.738.445-1.484.912-2.215 1.4-1.759 1.17-3.442 2.443-4.784 3.728-1.139 1.087-2.031 2.183-2.52 3.226a4.376 4.376 0 0 0-.364 1.135s-1.177 2.005 6.846 4.67c8.27 2.743 26.78 4.656 36.972 4.77 2.695.03 8.005-.22 10.536-.62 21.41-3.364 82.07-17.403 92.206-19.989 3.797-.97 8.904-2.352 14.103-4.256a83.857 83.857 0 0 0 5.982-2.435 61.6 61.6 0 0 0 3.247-1.59c2.852-1.507 5.486-3.211 7.645-5.141 1.769-1.578 3.23-3.303 4.24-5.193.538-1.007.836-1.916.955-2.736.214-1.494-.172-2.694-.809-3.676-1.243-1.902-3.263-3.69-3.851-4.525-.588-.832-2.525-2.494-4.99-4.681-1.258-1.121-2.698-2.194-4.26-2.997-.88-.453-1.8-.82-2.746-1.06-2.372-.601-5.645-1.048-9.857-1.05h-.086z",
    mask: "url(#H)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#6B6B6B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.843 92.083c0 .538.448.975 1 .975.553 0 1-.437 1-.975v-1.05a.988.988 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM282.843 93.083c0 .538.448.975 1 .975s1-.437 1-.975v-1.05a.988.988 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM285.843 94.083c0 .538.448.975 1 .975.553 0 1-.437 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM288.843 95.083c0 .538.448.975 1 .975.553 0 1-.437 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM290.843 95.083c0 .539.448.975 1 .975.553 0 1-.436 1-.975v-1.05a.988.988 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM293.843 96.083c0 .538.448.975 1 .975.553 0 1-.437 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .436-1 .974v1.05zM296.843 97.082c0 .539.448.976 1 .976.553 0 1-.437 1-.976v-1.05a.987.987 0 0 0-1-.974c-.552 0-1 .437-1 .974v1.05zM298.843 98.082c0 .54.448.976 1 .976.553 0 1-.437 1-.976v-1.05a.987.987 0 0 0-1-.974c-.552 0-1 .436-1 .974v1.05zM301.843 98.084c0 .538.448.974 1 .974.553 0 1-.436 1-.974v-1.05a.988.988 0 0 0-1-.976c-.552 0-1 .437-1 .975v1.05zM304.843 99.083c0 .538.448.975 1 .975.553 0 1-.437 1-.975v-1.05a.988.988 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM307.843 100.083c0 .539.448.975 1 .975.553 0 1-.436 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .436-1 .976v1.049zM309.843 101.084c0 .537.448.974 1 .974.553 0 1-.437 1-.974v-1.05a.988.988 0 0 0-1-.976c-.552 0-1 .437-1 .975v1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.843 100.082c0 .539.448.976 1 .976.553 0 1-.437 1-.976v-1.05a.987.987 0 0 0-1-.974c-.552 0-1 .436-1 .974v1.05zM305.843 101.084c0 .538.448.974 1 .974.553 0 1-.436 1-.974v-1.05a.988.988 0 0 0-1-.976c-.552 0-1 .437-1 .976v1.05zM308.843 101.082c0 .539.448.976 1 .976.553 0 1-.437 1-.976v-1.05a.987.987 0 0 0-1-.974c-.552 0-1 .437-1 .975v1.049zM311.843 102.083c0 .538.448.975 1 .975.553 0 1-.437 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .436-1 .975v1.05zM313.843 103.083c0 .539.448.975 1 .975.553 0 1-.436 1-.975v-1.05a.988.988 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM316.843 103.083c0 .539.448.975 1 .975.553 0 1-.436 1-.975v-1.05a.988.988 0 0 0-1-.975c-.552 0-1 .437-1 .976v1.05zM319.843 104.082c0 .54.448.976 1 .976.553 0 1-.436 1-.976v-1.049a.988.988 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM322.843 105.083c0 .539.448.975 1 .975.553 0 1-.436 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .436-1 .975v1.05zM325.843 106.084c0 .538.448.974 1 .974.553 0 1-.436 1-.974v-1.05a.988.988 0 0 0-1-.976c-.552 0-1 .437-1 .976v1.05zM328.843 107.083c0 .538.448.975 1 .975.553 0 1-.437 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .436-1 .974v1.05zM331.843 108.083c0 .539.448.975 1 .975.553 0 1-.436 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .436-1 .975v1.05z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 443 67.796)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "K",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#J)",
    xlinkHref: "#I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53.565c-.64.11-1.408.258-2.163.458C1.727 1.455.143 2.127 0 3.11c-.058.396 3.507 1.363 9.341 2.684 24.895 5.638 91.101 17.705 93.374 19.297 2.804 1.965 17.417 7.896 21.025 10.95 6.854 5.806 8.524 6.99 18.46 3.785 5.66-1.823 10.882-3.657 15.972-5.945 3.707-1.664 5.817-4.055 4.937-5.94 0 0-.33-3.76-4.895-6.905-.59-.403-1.2-.77-1.831-1.088a14.786 14.786 0 0 0-1.828-.76c-3.44-1.176-7.6-1.366-11.494-1.458-2.63-.06-5.14-.077-7.22-.32C129.942 16.719 7.118.348 7.118.348S6.453.413 5.53.565",
    mask: "url(#K)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 347.09 76.927)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "N",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M11.27 1.342C3.512 3.802-1.12 10.118.841 15.23c1.963 5.11 9.72 6.929 17.531 4.622 9.598-2.837 11.7-8.836 9.738-13.947C26.73 2.3 23.053.198 18.09.198c-2.073 0-4.372.367-6.82 1.144",
    mask: "url(#N)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 344.106 76.058)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.014 1.267C3.258 3.727-1.373 10.043.588 15.154c1.962 5.11 9.72 6.93 17.53 4.622 9.599-2.837 11.701-8.836 9.739-13.945C26.474 2.225 22.797.123 17.834.124c-2.073 0-4.372.367-6.82 1.143",
    mask: "url(#P)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 330.465 79.101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "S",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M1.946.378c-.17.053-.33.116-.492.18C.2 2.431-.156 4.971.72 7.456c1.186 3.36 4.247 5.569 7.392 5.62 2.408-1.547 3.46-4.765 2.36-7.886C9.39 2.123 6.577.118 3.705.118c-.589 0-1.18.084-1.759.26",
    mask: "url(#S)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F6F8",
    d: "M323.572 77.076c.629 0 1.25.093 1.845.274 1.734.527 3.106 1.76 3.866 3.469.767 1.726.819 3.73.144 5.64-1.125 3.186-4.08 5.413-7.19 5.413a6.334 6.334 0 0 1-1.845-.274c-1.733-.527-3.106-1.759-3.866-3.468-.766-1.728-.817-3.732-.142-5.642 1.123-3.187 4.079-5.412 7.188-5.412m-1.336 15.418c3.395 0 6.614-2.401 7.828-5.84.723-2.053.665-4.21-.162-6.073-.836-1.88-2.354-3.238-4.276-3.822a7.074 7.074 0 0 0-2.054-.305c-3.395 0-6.612 2.401-7.826 5.839-.724 2.054-.666 4.21.162 6.074.836 1.879 2.353 3.237 4.274 3.823a7.057 7.057 0 0 0 2.054.304"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 372.666 73.449)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "V",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#T"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M10.328 1.058C3.24 3.305-.991 9.076.8 13.745c1.792 4.67 8.88 6.332 16.017 4.224 8.77-2.591 10.691-8.074 8.898-12.742C24.453 1.932 21.094.013 16.559.013c-1.894 0-3.994.335-6.231 1.045",
    mask: "url(#V)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 370.108 72.58)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "X",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#W"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.264 1.064C3.177 3.311-1.054 9.082.737 13.752c1.793 4.67 8.88 6.332 16.017 4.224 8.77-2.592 10.69-8.073 8.898-12.743C24.388 1.94 21.029.02 16.495.02c-1.894 0-3.994.335-6.23 1.044",
    mask: "url(#X)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 357.32 75.188)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aa",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M1.653.425a5.75 5.75 0 0 0-.45.163C.059 2.3-.267 4.62.533 6.89c1.084 3.072 3.881 5.089 6.755 5.137 2.2-1.416 3.16-4.355 2.156-7.206C8.455 2.019 5.885.187 3.261.187a5.49 5.49 0 0 0-1.608.238",
    mask: "url(#aa)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F6F8",
    d: "M351.147 73.416c.575 0 1.142.085 1.685.25 1.585.483 2.838 1.608 3.533 3.169.7 1.578.748 3.409.131 5.154-1.027 2.911-3.728 4.946-6.57 4.946a5.78 5.78 0 0 1-1.684-.25c-1.585-.481-2.839-1.608-3.533-3.17-.7-1.578-.747-3.409-.13-5.154 1.027-2.912 3.727-4.945 6.568-4.945m-1.22 14.088c3.102 0 6.042-2.195 7.152-5.337.66-1.875.608-3.847-.149-5.549-.763-1.717-2.15-2.958-3.907-3.491a6.45 6.45 0 0 0-1.876-.28c-3.102 0-6.041 2.195-7.15 5.337-.662 1.874-.61 3.845.147 5.55.764 1.716 2.15 2.956 3.906 3.492a6.466 6.466 0 0 0 1.876.278"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 396.537 104.755)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ac",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ab"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.852.214C2.954.404.124 2.184.124 2.184s.043.01.125.022l.052.008c.27.043.846.132 1.672.26 8.35 1.304 42.248 6.562 44.474 6.478.52-.022 1.247-.213 2.07-.51 3.184-1.142 7.83-3.804 7.83-3.804s.831-.983.538-1.543a.536.536 0 0 0-.08-.11c-.164-.176-.492-.284-1.063-.263-.409.016-2.161-.06-4.782-.194C39.34 1.936 10.65.205 6.268.204c-.182 0-.321.003-.416.01",
    mask: "url(#ac)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 364.567 72.417)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ag",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ad"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#ae)",
    xlinkHref: "#ad"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M-10.26 39.022c30.479 9.776 70.051 6.423 99.02-3.352 25.526-8.795 52.97-26.142 80.748-25.464 20.225.163 29.188 8.212 48.07 15.173l12.383 77.832-194.795-5.58-45.425-58.61z",
    mask: "url(#ag)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB300",
    d: "M189.017 70.5l9.13.412 1.586-2.069-8.514-.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB300",
    d: "M189.212 70.332l2.983.163 1.592-1.844-2.568-.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0D700",
    d: "M199.747 71.007l6.289.48 1.294-2.19-6.16-.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B6B6B",
    d: "M233.567 76.256c0 .538.448.975 1 .975.553 0 1-.437 1-.975v-1.05a.988.988 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM236.567 77.257c0 .537.447.974 1 .974.552 0 1-.437 1-.974v-1.05a.987.987 0 0 0-1-.976c-.553 0-1 .437-1 .975v1.05zM239.567 78.256c0 .54.447.975 1 .975.553 0 1-.436 1-.975v-1.049a.987.987 0 0 0-1-.976c-.553 0-1 .437-1 .976v1.05zM242.567 79.256c0 .539.448.975 1 .975s1-.436 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM245.567 80.256c0 .539.448.975 1 .975.553 0 1-.436 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM248.567 81.256c0 .538.447.975 1 .975.552 0 1-.437 1-.975v-1.05a.988.988 0 0 0-1-.975c-.553 0-1 .437-1 .975v1.05zM251.567 82.256c0 .539.448.975 1 .975.553 0 1-.436 1-.975v-1.05a.987.987 0 0 0-1-.975c-.552 0-1 .437-1 .975v1.05zM254.567 83.256c0 .539.447.975 1 .975.552 0 1-.436 1-.975v-1.05a.988.988 0 0 0-1-.975c-.553 0-1 .437-1 .975v1.05zM257.567 84.256c0 .54.447.975 1 .975.552 0 1-.436 1-.975v-1.05a.988.988 0 0 0-1-.975c-.553 0-1 .436-1 .975v1.05zM260.567 85.257c0 .538.447.974 1 .974.553 0 1-.436 1-.974v-1.05a.987.987 0 0 0-1-.976c-.553 0-1 .436-1 .975v1.05zM263.567 86.256c0 .539.447.975 1 .975.552 0 1-.436 1-.975v-1.05a.989.989 0 0 0-1-.975c-.553 0-1 .437-1 .976v1.049zM266.567 87.256c0 .538.447.975 1 .975.553 0 1-.437 1-.975v-1.05a.987.987 0 0 0-1-.975c-.553 0-1 .437-1 .975v1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6B6B6B",
    strokeWidth: 0.55,
    d: "M220.67 76.438c-.23 1.838 1.428 3.542 3.706 3.806 2.278.262 4.305-1.017 4.535-2.855l.448-3.587c.229-1.838-1.425-3.54-3.703-3.804-2.278-.263-4.309 1.015-4.538 2.853l-.448 3.587z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B6B6B",
    d: "M224.177 72.693c-.01.237.107.434.26.44.155.006.288-.18.298-.417.01-.237-.106-.434-.26-.44-.154-.007-.287.18-.298.417"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    opacity: 0.234
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.882 80h-14.764c-.617 0-1.118.448-1.118 1s.5 1 1.118 1h14.764c.618 0 1.118-.448 1.118-1s-.5-1-1.118-1M109.882 78H95.118c-.617 0-1.118.448-1.118 1s.5 1 1.118 1h14.764c.618 0 1.118-.448 1.118-1s-.5-1-1.118-1M107.882 82H93.118c-.617 0-1.118.448-1.118 1s.5 1 1.118 1h14.764c.618 0 1.118-.448 1.118-1s-.5-1-1.118-1"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    opacity: 0.234
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.882 47h-14.764c-.617 0-1.118.448-1.118 1s.5 1 1.118 1h14.764c.618 0 1.118-.448 1.118-1s-.5-1-1.118-1M262.882 45h-14.764c-.617 0-1.118.448-1.118 1s.5 1 1.118 1h14.764c.618 0 1.118-.448 1.118-1s-.5-1-1.118-1M260.882 49h-14.764c-.617 0-1.118.448-1.118 1s.5 1 1.118 1h14.764c.618 0 1.118-.448 1.118-1s-.5-1-1.118-1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F2DD23",
    d: "M300.06 85.516c-.78.91-.78 2.238.002 3.984.781 1.746 1.783 2.874 3.006 3.385l4.246-1.194c-1.904-1.489-3.01-2.662-3.32-3.52-.31-.86-.186-1.778.372-2.757l-4.306.102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB300",
    d: "M307.332 91.69l4.13 2.703-4.124 1.28-4.288-2.774z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerflightgrey);
export default __webpack_public_path__ + "static/media/bannerflightgrey.082f84a27a760eb348a0f4e88c7e1e07.svg";
export { ForwardRef as ReactComponent };